import { useEffect, useState, useRef } from "react";

export function useScrollShadow() {
  const ref = useRef(null);
  const [hasTopShadow, setHasTopShadow] = useState(false);
  const [hasBottomShadow, setHasBottomShadow] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const updateShadows = () => {
      const { scrollTop, scrollHeight, clientHeight } = el;

      // بالا اسکرول شده؟
      setHasTopShadow(scrollTop > 0);

      // آیا هنوز پایین محتوا هست؟
      setHasBottomShadow(scrollTop + clientHeight < scrollHeight - 1);
    };

    // ✅ چک اولیه بلافاصله بعد از mount
    // (requestAnimationFrame برای اینه که layout کامل شده باشه)
    const rafId = window.requestAnimationFrame(updateShadows);

    // ✅ گوش دادن به اسکرول
    el.addEventListener("scroll", updateShadows);

    // ✅ هر تغییری توی سایز/محتوا رو هم بگیر
    let resizeObserver;
    if (typeof ResizeObserver !== "undefined") {
      resizeObserver = new ResizeObserver(updateShadows);
      resizeObserver.observe(el);
    } else {
      // fallback ساده در صورت نبود ResizeObserver
      window.addEventListener("resize", updateShadows);
    }

    return () => {
      window.cancelAnimationFrame(rafId);
      el.removeEventListener("scroll", updateShadows);

      if (resizeObserver) {
        resizeObserver.disconnect();
      } else {
        window.removeEventListener("resize", updateShadows);
      }
    };
  }, []);

  return { ref, hasTopShadow, hasBottomShadow };
}
